import theme, { COLORS, SIZES, FONTS } from './theme'
import images from './images'
import axios from "axios";
const API_URL = 'https://server.accept.konsensus.tech';
//const API_URL = 'http://localhost:5001';
const FORUM_URL = 'https://forum.accept.konsensus.tech';
const APP_URL = 'https://app.accept.konsensus.tech';
const NEM_URL = 'https://meeting.konsensus.tech';

const UPLOAD_STATE_KEY = 'konsensus_upload_state';
const NAVIGATION_STATE_KEY = 'konsensus_navigation_state';
const MOVE_STATE_KEY = 'konsensus_move_state';
const SYNC_STATE_KEY = 'konsensus_sync_state';

const AXIOS_CONFIG = {
    headers: {
        'Accept':'application/json',
        'accept': 'application/json',
        'Content-Type':'application/json',
    }
}

async function _retrieveDataLocal(key){
    try {
        const value = await localStorage.getItem('@Konsensus:'+key);
        let value_parsed = JSON.parse(value);
        // check last_login
        let dt = new Date();
        dt.setDate( dt.getDate() - 1 );
        if( value_parsed!==null ) {
            // console.log(new Date(value_parsed.user.last_login).toDateString() + '<' + dt.toDateString());
            return {[key]: value_parsed};
        }else{
            // console.log("weird:" + value_parsed);
            return false;
        }
    } catch (error) {
        // Error retrieving data
        console.log("Error:" + error);
        return false;
    }
};

async function _storeData(key, value){
    try {
        await localStorage.setItem('@Konsensus:'+key, JSON.stringify(value));
        // console.log("Stored " + key + " value: "+value);
    } catch (error) {
        // Error saving data
        console.log("Error Stored " + error);
    }
};

async function clear(){
    try {
        localStorage.removeItem(NAVIGATION_STATE_KEY);
        localStorage.removeItem(UPLOAD_STATE_KEY);
        localStorage.removeItem(MOVE_STATE_KEY);
        localStorage.removeItem(SYNC_STATE_KEY);
        _removeItem("nem");
        _removeItem("login_response");
        _removeItem("nem_notifications");
        // console.log("Stored " + key + " value: "+value);
    } catch (error) {
        // Error saving data
        console.log("Error Clearing " + error);
    }
};

async function _removeItem(key){
    try {
        await localStorage.removeItem('@Konsensus:'+key);
        // console.log("Stored " + key + " value: "+value);
    } catch (error) {
        // Error saving data
        console.log("Error removing " + error);
    }
};

export default {
    API_URL,
    FORUM_URL,
    APP_URL,
    NEM_URL,
    AXIOS_CONFIG,
    _retrieveDataLocal,
    _storeData,
    clear,
};
export { images, theme, COLORS, SIZES, FONTS }

